import React, { useState } from 'react';

import PropTypes from 'prop-types';
import Modal from '@tds/community-modal';

import request from '../../utils/request';
import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';
import { Button } from './css';

const CancelOrder = ({ orderData, fetchOrders }) => {
  const { id, isQuoteReference } = orderData;
  const localizedStrings = useLocalizedStringsContext();
  const {
    srtDashboard: { confirmationDialog, cancel },
    formButtons: { confirmButtonLabel, cancelButtonLabel }
  } = localizedStrings;

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleCancelOrder = () => {
    request.delete(`/orders/${id}`).then(() => {
      fetchOrders();
      setIsModalOpen(false);
    });
  };

  if (isQuoteReference) return null;

  return (
    <>
      <Button onClick={() => setIsModalOpen(true)}>{cancel}</Button>
      <Modal
        heading={confirmationDialog}
        bodyText="Are you sure you want to cancel this order?"
        confirmCTAText={confirmButtonLabel}
        cancelCTAText={cancelButtonLabel}
        onConfirm={() => handleCancelOrder()}
        onClose={() => setIsModalOpen(false)}
        isOpen={isModalOpen}
      />
    </>
  );
};

CancelOrder.propTypes = {
  orderData: PropTypes.objectOf(PropTypes.object).isRequired,
  fetchOrders: PropTypes.func.isRequired
};

export default CancelOrder;
